import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../../redux/feature/dataReducer";
import ShoppingCard from "../shoppingCard/ShoppingCard";

const FetchData = () => {
  const { dataList, loading } = useSelector((state) => state.data);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getData());
  }, []);

  return (
    <div className="container d-flex justify-content-center align-items-center flex-wrap text-center">
      {loading ? (
        <div style={{ height: "100vh", marginTop: "10rem" }}>
          <span className="loaderGif"></span>
        </div>
      ) : (
        dataList?.map((item) => {
          return <ShoppingCard key={item.id} item={item} />;
        })
      )}
    </div>
  );
};

export default FetchData;
